<template>
    <a
        v-bind="$attrs"
        class="search-result-individual"
        :data-bot="context ? `search-result__individual--${context}` : 'search-result__individual'"
        :class="classes"
        :href="link"
        @mouseenter="handleMouseEnter"
        @mouseleave="isHovered = false"
    >
        <CompassObject size="extra-small" type="object" object="individual" />
        <div class="search-result-individual__content">
            <div class="search-result-individual__title">
                <h5
                    class="search-result-individual__name typographies-paragraph-medium-bold"
                    v-html="name"
                />
                <TagThird :label="typeLabel" :type="type" size="extra-small" />
            </div>
            <p
                v-if="address"
                class="search-result-individual__address typographies-paragraph-medium-regular"
                v-html="address"
            />
            <div
                v-for="(extraField, index) in getHighlightedExtraFields"
                :key="index"
                class="typographies-paragraph-medium-regular search-result-individual__extra-field"
            >
                <span> {{ extraField.label }}</span>
                <span v-html="extraField.value" />
            </div>
        </div>
    </a>
</template>
<script>
import SearchResultsGeneric from './SearchResultsGeneric.vue';
import TagThird from 'vcomponents/common/TagThird/TagThird.vue';

export default {
    components: {
        TagThird,
    },
    extends: SearchResultsGeneric,
    props: {
        address: {
            type: [String, Boolean],
            default: '',
        },
        name: {
            type: String,
            required: true,
        },
        type: {
            type: String,
            required: true,
        },
    },
    computed: {
        typeLabel() {
            switch (this.type) {
                case 'client':
                    return this.$l10n.__('Client');
                case 'prospect':
                    return this.$l10n.__('Prospect');
                case 'supplier':
                    return this.$l10n.__('Fournisseur');
                default:
                    return '';
            }
        },
        classes() {
            return {
                'search-result-individual--is-hovered': this.isHovered,
            };
        },
    },
};
</script>
<style lang="scss" scoped>
.search-result-individual {
    align-items: flex-start;
    cursor: pointer;
    display: flex;
    gap: var(--spacing-1);
    padding: var(--spacing-1) var(--spacing-3);

    &--is-hovered {
        background: var(--colors-common-background-hover, #f6f6f9);
    }

    &__name {
        color: var(--colors-common-text-standard-default, #111);
        margin: 0;
    }

    &__title {
        align-items: center;
        display: flex;
        gap: var(--spacing-1);
    }

    &__address {
        color: var(--colors-common-text-subtle-default, #565665);
        margin: var(--spacing-0) 0 0;
    }

    :deep(.highlight) {
        background: var(--colors-common-background-highlight-search);
    }

    &__extra-field {
        color: var(--colors-common-text-subtle-default, #565665);
        display: flex;
        gap: var(--spacing-0);
        padding: var(--spacing-0) 0 0;
    }
}
</style>
